import BoardCommentForm from "@/features/Board/BoardCommentForm/BoardCommentForm";
import BoardCommentList from "@/features/Board/board-commentlist";

import HomeSectionDescription from "../Home/components/home-section-description";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import gsap from "gsap";
import HomeSectionTitle from "../Home/components/home-section-title";
import SubNav from "@/components/shared/sub-nav";
import { useAuthentication, useUser } from "@/hooks/useAuth";

export default function Board() {
  const bgEffectRef = useRef<HTMLDivElement>(null);
  const titlePreRef = useRef<HTMLSpanElement[]>([]);
  const titlePostRef = useRef<HTMLSpanElement[]>([]);
  const authentication = useAuthentication();
  const user = useUser();

  const fadeDivs = useRef<HTMLElement[]>([]);

  useGSAP(() => {
    const bgEffect = bgEffectRef.current;

    const tl = gsap.timeline();

    // 1. Background - 더 부드럽게
    gsap.from(bgEffect, {
      opacity: 0,
    });

    tl.from(titlePreRef.current, {
      opacity: 0,
      x: 50,
      filter: "blur(15px) grayscale(0%)",
      stagger: 0.01,
      duration: 0.9,
      ease: "power2.out",
      delay: 0.3,
    });

    tl.from(
      titlePostRef.current,
      {
        opacity: 0,
        x: 30,
        filter: "blur(5px) grayscale(0%)",
        stagger: 0.02,
        duration: 1,
        ease: "power2.out",
      },
      "-=0.6"
    );

    gsap.utils.toArray(fadeDivs.current).forEach((e) => {
      const el = e as HTMLDivElement;
      tl.from(
        el,
        {
          x: 40,
          opacity: 0,
          filter: "blur(5px)",
          duration: 0.7,
          ease: "power2.out",
        },
        "-=0.6"
      );
    });
  });

  return (
    <div className="bg-[#171717] relative  ">
      {/* 배경 이미지 - 가장 뒤 */}

      <div className="w-full h-[800px] bg-cover bg-bottom opacity-70 absolute  will-change-transform transform-gpu">
        <div
          ref={bgEffectRef}
          className="absolute inset-0 grayscale bg-cover bg-bottom opacity-70 "
          style={{
            backgroundImage: "url(/img/hero/b9.jpg)",
          }}
        />
        {/* <ArticleEffect /> */}

        <div className="absolute bottom-0 w-full left-0 h-full bg-linear-to-b from-transparent via-[#171717]/40 to-[#171717]" />
      </div>

      {/* 메인 컨텐츠 - 가장 앞 */}
      <div className="grid-layout pt-50 md:pt-60  lg:gap-40 grid lg:grid-cols-[auto_1fr] relative z-10">
        <div>
          <div className="flex flex-col items-start sticky top-60">
            <HomeSectionTitle className="text-zinc-50 ">
              <div className="inline-block text-zinc-50 ">
                {"한줄의 응원 메세지는,".split("").map((e, i) => (
                  <span
                    key={`word:${i}`}
                    ref={(el) => {
                      if (el) {
                        titlePreRef.current[i] = el;
                      }
                    }}
                    className="inline-block "
                  >
                    {e === " " ? "\u00A0" : e}
                  </span>
                ))}
              </div>
              <div>
                {"저에게 큰 힘이 됩니다".split("").map((e, i) => (
                  <span
                    key={`word:${i}`}
                    ref={(el) => {
                      if (el) {
                        titlePostRef.current[i] = el;
                      }
                    }}
                    className=" inline-block "
                  >
                    {e === " " ? "\u00A0" : e}
                  </span>
                ))}
              </div>
            </HomeSectionTitle>
            <div ref={(el) => (fadeDivs.current[0] = el!)}>
              <HomeSectionDescription className="text-zinc-300 mb-10 mt-10 ">
                <p className="break-keep!">
                  프로젝트의 목표를 <br></br>함께 완성해 나갈 동료가 되겠습니다
                </p>
              </HomeSectionDescription>

              <div className="md:flex lg:flex-col gap-10 lg:gap-3">
                <SubNav />
              </div>
            </div>
          </div>{" "}
        </div>
        <section
          className=" gap-40 md:mt-auto mt-20 "
          ref={(el) => (fadeDivs.current[1] = el!)}
        >
          <div>
            <p className="text-xs opacity-80">Comment Form</p>
            {authentication && (
              <div className="flex items-center gap-2 pt-5">
                <div className="shrink-0 w-8">
                  <div className="relative size-8 rounded-full overflow-hidden ring-2 ring-zinc-600/60 transition-all">
                    {user && (
                      <img
                        src={"/img/my-dog.webp"}
                        alt={user.nickname || ""}
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                </div>
                <span className="text-sm font-medium text-zinc-200">
                  {user?.nickname}
                </span>
                <span className=" py-0.5 text-[10px] font-semibold text-pink-400 rounded">
                  ADMIN
                </span>
              </div>
            )}

            <BoardCommentForm />
          </div>
          <div className="mt-10 flex flex-col ">
            <BoardCommentList />
          </div>
        </section>
      </div>
    </div>
  );
}
